module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container pa-0"
  }, [_c('div', [_c('figure', {
    staticClass: "pb-3 text-center"
  }, [_c('UploadIcon', {
    on: {
      "clicked": function($event) {
        return _vm.driveIconClicked()
      }
    }
  }), _vm._v(" "), _c('h4', {
    on: {
      "click": function($event) {
        return _vm.driveIconClicked()
      }
    }
  }, [_vm._v("Connect to Google Drive")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4de1f01e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/gdrive/GDriveSelector.vue
// module id = 2117
// module chunks = 0